// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonBranchNewTrack_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 12H4V16H0V12ZM9 0H13V4H9V0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.12609 9.85504C3.4932 10.4567 3 11.3595 3 13H1C1 10.9739 1.6318 9.58499 2.68641 8.58246C3.6667 7.65058 4.94573 7.12981 6.02159 6.69177C6.04579 6.68192 6.06988 6.67211 6.09386 6.66234C7.25341 6.18993 8.18874 5.79629 8.87391 5.14496C9.5068 4.54332 10 3.64055 10 2H12C12 4.02612 11.3682 5.41501 10.3136 6.41754C9.3333 7.34942 8.05427 7.87019 6.97841 8.30823C6.95421 8.31808 6.93012 8.32789 6.90614 8.33766C5.74659 8.81007 4.81126 9.20371 4.12609 9.85504Z" class="svg-bg"/>
  <path d="M0 0H4V4H3V7.0672C2.65161 7.29732 2.31226 7.55839 1.99742 7.85768C1.61281 8.2233 1.27891 8.62944 1 9.08016V4H0V0Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonBranchNewTrack is a generated icon component.
 */
let IconCommonBranchNewTrack = IconCommonBranchNewTrack_1 = class IconCommonBranchNewTrack extends IconBaseElement {
    render() {
        return html `${IconCommonBranchNewTrack_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonBranchNewTrack.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonBranchNewTrack = IconCommonBranchNewTrack_1 = __decorate([
    customElement('zui-icon-common-branch-new-track')
], IconCommonBranchNewTrack);
export { IconCommonBranchNewTrack };
